// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"929df416","455":"2361e3f0","977":"9052386f"}[chunkId] + ".chunk.js";
};